import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useUrlParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const addChangeParamToUrl = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    if (!searchParams.has('newChange') || searchParams.get('newChange') !== 'true') {
      searchParams.set('newChange', 'true');
      navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
    }
  }, [location, navigate]);

  const removeChangeParamFromUrl = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('newChange')) {
      searchParams.delete('newChange');
      navigate(`${location.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`, {
        replace: true,
      });
    }
  }, [location, navigate]);

  return {
    addChangeParamToUrl,
    removeChangeParamFromUrl,
  };
};
